import "./ui/styles.css";
import "./ui/club.css";
import { onRouteChange, type Route } from "./app/router";
import { mountAnteroom } from "./views/anteroom";
import { mountLearn } from "./views/learn";
import { KnowledgePanel } from "./ui/knowledge";

const app = document.querySelector<HTMLElement>("#app");
if (!app) throw new Error("#app missing");

const panel = new KnowledgePanel(document.body);
let active: { destroy: () => void } | null = null;
let lastRoute: Route | null = null;

function render(route: Route) {
  if (route === lastRoute && active) return;
  lastRoute = route;

  active?.destroy();
  panel.close();

  if (route === "learn") {
    active = mountLearn(app!, panel);
  } else {
    active = mountAnteroom(app!, panel);
  }
}

onRouteChange((route) => render(route));

window.addEventListener("beforeunload", () => {
  active?.destroy();
  panel.root.remove();
});
